// Branding centralizado (nome + logo). DEFAULT = marca NEUTRA do produto (AURA),
// nunca de um cliente — o produto é white-label. Cada operadora sobe o SEU logo
// pela tela Administração -> Operadora (guardado no banco em logo_url, que tem
// precedência sobre este default). Este arquivo é só o fallback de fábrica.
//
//   REACT_APP_BRAND_NAME  -> nome do produto exibido (override de build, opcional)
//   REACT_APP_BRAND_LOGO  -> logo de build (override, opcional)
import defaultLogo from './assets/brand-logo.svg';

export const BRAND_NAME = process.env.REACT_APP_BRAND_NAME || 'AURA';
export const BRAND_LOGO = process.env.REACT_APP_BRAND_LOGO || defaultLogo;
export const BRAND_LOGO_LOGIN = process.env.REACT_APP_BRAND_LOGO || defaultLogo;
